import { defineDocument } from '../../schema';
export const featurePoppyDocument = defineDocument({
    id: 'feature:poppy',
    kind: 'feature',
    slug: 'poppy',
    route: '/discover/features/poppy',
    seo: {
        title: 'Discover Poppy',
        description: 'Meet Poppy, your game host. Learn how to use the in-game menu and bring Poppy into your Twitch chat.',
    },
    hero: {
        eyebrow: [
            {
                type: 'text',
                text: 'Discover Feature',
            },
        ],
        title: [
            {
                type: 'text',
                text: 'Poppy',
            },
        ],
        description: [
            {
                type: 'text',
                text: 'Meet Poppy, your game host. Learn how to use the in-game menu and bring Poppy into your Twitch chat.',
            },
        ],
    },
    aside: {
        showToc: true,
    },
    sections: [
        {
            id: 'about-poppy',
            title: [
                {
                    type: 'text',
                    text: 'About Poppy',
                },
            ],
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: "Poppy is the dynamic host who brings Airhead Games to life. They guide every game and adapt to your group to create a personalized experience unlike any other party games. Whether Poppy is cracking jokes, roasting players, or defusing a tense moment, the goal is always the same: bring joy to your group and strengthen your community's connection.",
                        },
                    ],
                },
                {
                    type: 'image',
                    imageAsset: 'featurePoppyPfp',
                    imageAlt: 'Poppy, our beloved game host, with an animated facial expression',
                    caption: [
                        {
                            type: 'text',
                            text: 'Poppy guides every moment of gameplay.',
                        },
                    ],
                    maxWidth: 400,
                },
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Unlike static party games with repetitive, recycled content, Poppy generates fresh content on the fly. Prompts, images, and commentary are all created in real time based on the players, gameplay context, and ',
                        },
                        {
                            type: 'link',
                            href: '/discover/features/user-preferences',
                            children: [
                                {
                                    type: 'text',
                                    text: 'user preferences',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: '. No two games are exactly alike.',
                        },
                    ],
                },
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'The Pop-sibilities are endless.',
                        },
                    ],
                },
            ],
        },
        {
            id: 'in-game-menu',
            title: [
                {
                    type: 'text',
                    text: 'In-Game Menu',
                },
            ],
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'During gameplay, the host can hover on Poppy to show the menu icon in their mouth. Click to open. The in-game menu provides quick access to essential controls without leaving the game room.',
                        },
                    ],
                },
                {
                    type: 'image',
                    imageAsset: 'featurePoppyHover',
                    imageAlt: 'Poppy showing the menu icon when hovered.',
                    caption: [
                        {
                            type: 'text',
                            text: "Hover on Poppy to show the menu icon in Poppy's mouth.",
                        },
                    ],
                    maxWidth: 400,
                },
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'The in-game menu includes:',
                        },
                    ],
                },
                {
                    type: 'list',
                    items: [
                        [
                            {
                                type: 'link',
                                href: '/discover/features/audio#audio-experience__mute-state',
                                children: [
                                    {
                                        type: 'text',
                                        text: 'Mute Toggle',
                                    },
                                ],
                            },
                            {
                                type: 'text',
                                text: ' - Quickly mute all audio.',
                            },
                        ],
                        [
                            {
                                type: 'link',
                                href: '/discover/features/audio#audio-experience__volume-controls',
                                children: [
                                    {
                                        type: 'text',
                                        text: 'Volume Controls',
                                    },
                                ],
                            },
                            {
                                type: 'text',
                                text: ' - Independently adjust audio levels for music, voice, and sound effects.',
                            },
                        ],
                        [
                            {
                                type: 'link',
                                href: '/discover/features/moderator-tools#player-access__remove-player',
                                children: [
                                    {
                                        type: 'text',
                                        text: 'Remove Player',
                                    },
                                ],
                            },
                            {
                                type: 'text',
                                text: ' - Remove individual players from the room.',
                            },
                        ],
                        [
                            {
                                type: 'strong',
                                children: [
                                    {
                                        type: 'text',
                                        text: 'End Game',
                                    },
                                ],
                            },
                            {
                                type: 'text',
                                text: ' - Close the game room for all players.',
                            },
                        ],
                    ],
                },
            ],
        },
        {
            id: 'poppy-in-your-chat',
            title: [
                {
                    type: 'text',
                    text: 'Poppy in Your Chat',
                },
            ],
            blocks: [
                {
                    type: 'paragraph',
                    content: [
                        {
                            type: 'text',
                            text: 'Poppy can also join your Twitch chat and post useful information, automatically or on command. See ',
                        },
                        {
                            type: 'link',
                            href: '/discover/features/moderator-tools#poppy-in-twitch-chat',
                            children: [
                                {
                                    type: 'text',
                                    text: 'Moderator Tools',
                                },
                            ],
                        },
                        {
                            type: 'text',
                            text: ' to learn more about the features and how to set them up.',
                        },
                    ],
                },
                {
                    type: 'image',
                    imageAsset: 'featurePitcChat',
                    imageAlt: 'Twitch chat where Poppy posts a room join link and replies to a viewer command',
                    caption: [
                        {
                            type: 'text',
                            text: 'Poppy shares the join link and responds to commands in Twitch chat.',
                        },
                    ],
                },
            ],
        },
    ],
});
//# sourceMappingURL=poppy.js.map